import { HttpContextToken } from '@angular/common/http';

// Set to true on a request's HttpContext to opt it out of serverErrorInterceptor's
// automatic redirect to the 500 page (e.g. a request that already retries on its
// own and needs the real error to reach its own catchError).
export const BYPASS_GLOBAL_ERROR_PAGE = new HttpContextToken<boolean>(() => false);
